export default "__VITE_ASSET__DDXRYhH1__"